import { render } from "./CustomModelValue.vue?vue&type=template&id=6ca14e0e"
import script from "./CustomModelValue.vue?vue&type=script&lang=js"
export * from "./CustomModelValue.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__